import { JSONSchemaType } from "ajv"
import validateConstant, {
  e入力パターン,
} from "../../../constant/validateConstant"
import util from "../../../ts/util"
import { TNinusiRegisterPostReq, TNinusiUpdatePutReq } from "./TNinusi"

export const TNinusiRegisterPostReqSchema: JSONSchemaType<TNinusiRegisterPostReq> =
  {
    type: "object",
    properties: {
      荷主コード: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.荷主コード,
        pattern: validateConstant.PATTERN.英数字のみ,
        title: "荷主コード",
        errorMessage: util.stringErrorMessage("荷主コード", {
          required: true,
          maxLength: validateConstant.LENGTH.荷主コード,
          pattern: e入力パターン.英数字のみ,
        }),
      },
      荷主名: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.一般名称,
        title: "荷主名",
        errorMessage: util.stringErrorMessage("荷主名", {
          required: true,
          maxLength: 40,
        }),
      },
      荷主名カナ: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般カナ名称,
        title: "荷主名カナ",
        nullable: true,
        errorMessage: util.stringErrorMessage("荷主名カナ", {
          required: false,
          maxLength: validateConstant.LENGTH.一般カナ名称,
        }),
      },
      荷主略称1: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.一般略称,
        title: "荷主略称1",
        errorMessage: util.stringErrorMessage("荷主略称1", {
          required: true,
          maxLength: validateConstant.LENGTH.一般略称,
        }),
      },
      荷主略称2: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般略称,
        title: "荷主略称2",
        nullable: true,
        errorMessage: util.stringErrorMessage("荷主略称2", {
          required: false,
          maxLength: validateConstant.LENGTH.一般略称,
        }),
      },
      郵便番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.郵便番号,
        title: "郵便番号",
        nullable: true,
        errorMessage: util.stringErrorMessage("郵便番号", {
          required: false,
          maxLength: validateConstant.LENGTH.郵便番号,
        }),
      },
      住所１: {
        type: "string",
        maxLength: validateConstant.LENGTH.住所１,
        title: "住所１",
        nullable: true,
        errorMessage: util.stringErrorMessage("住所１", {
          required: false,
          maxLength: validateConstant.LENGTH.住所１,
        }),
      },
      住所２: {
        type: "string",
        maxLength: validateConstant.LENGTH.住所２,
        title: "住所２",
        nullable: true,
        errorMessage: util.stringErrorMessage("住所２", {
          required: false,
          maxLength: validateConstant.LENGTH.住所２,
        }),
      },
      住所３: {
        type: "string",
        maxLength: validateConstant.LENGTH.住所３,
        title: "住所３",
        nullable: true,
        errorMessage: util.stringErrorMessage("住所３", {
          required: false,
          maxLength: validateConstant.LENGTH.住所３,
        }),
      },
      電話番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.電話番号,
        title: "電話番号",
        nullable: true,
        errorMessage: util.stringErrorMessage("電話番号", {
          required: false,
          maxLength: validateConstant.LENGTH.電話番号,
        }),
      },
      FAX番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.電話番号,
        title: "FAX番号",
        nullable: true,
        errorMessage: util.stringErrorMessage("FAX番号", {
          required: false,
          maxLength: validateConstant.LENGTH.電話番号,
        }),
      },
      集計荷主コード: {
        type: "string",
        maxLength: validateConstant.LENGTH.汎用区分コード,
        title: "集計荷主",
        nullable: true,
        errorMessage: util.stringErrorMessage("集計荷主", {
          required: false,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      荷主担当者: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般名称,
        title: "荷主担当者",
        nullable: true,
        errorMessage: util.stringErrorMessage("荷主担当者", {
          required: false,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      インボイス登録番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.インボイス登録番号,
        title: "インボイス登録番号",
        nullable: true,
        errorMessage: util.stringErrorMessage("インボイス登録番号", {
          required: false,
          maxLength: validateConstant.LENGTH.インボイス登録番号,
        }),
      },
      歩合掛率: {
        type: "number",
        minimum: 0,
        title: "歩合掛率",
        nullable: false,
        errorMessage: util.stringErrorMessage("歩合掛率", {
          required: true,
        }),
      },
    },
    required: ["荷主コード", "荷主名", "荷主略称1", "歩合掛率"],
  }

export const TNinusiUpdatePutReqSchema: JSONSchemaType<TNinusiUpdatePutReq> = {
  type: "object",
  properties: {
    荷主コード: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.荷主コード,
      pattern: validateConstant.PATTERN.英数字のみ,
      title: "荷主コード",
      errorMessage: util.stringErrorMessage("荷主コード", {
        required: true,
        maxLength: validateConstant.LENGTH.荷主コード,
        pattern: e入力パターン.英数字のみ,
      }),
    },
    荷主名: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.一般名称,
      title: "荷主名",
      errorMessage: util.stringErrorMessage("荷主名", {
        required: true,
        maxLength: 40,
      }),
    },
    荷主名カナ: {
      type: "string",
      maxLength: validateConstant.LENGTH.一般カナ名称,
      title: "荷主名カナ",
      nullable: true,
      errorMessage: util.stringErrorMessage("荷主名カナ", {
        required: false,
        maxLength: validateConstant.LENGTH.一般カナ名称,
      }),
    },
    荷主略称1: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.一般略称,
      title: "荷主略称1",
      errorMessage: util.stringErrorMessage("荷主略称1", {
        required: true,
        maxLength: validateConstant.LENGTH.一般略称,
      }),
    },
    荷主略称2: {
      type: "string",
      maxLength: validateConstant.LENGTH.一般略称,
      title: "荷主略称2",
      nullable: true,
      errorMessage: util.stringErrorMessage("荷主略称2", {
        required: false,
        maxLength: validateConstant.LENGTH.一般略称,
      }),
    },
    郵便番号: {
      type: "string",
      maxLength: validateConstant.LENGTH.郵便番号,
      title: "郵便番号",
      nullable: true,
      errorMessage: util.stringErrorMessage("郵便番号", {
        required: false,
        maxLength: validateConstant.LENGTH.郵便番号,
      }),
    },
    住所１: {
      type: "string",
      maxLength: validateConstant.LENGTH.住所１,
      title: "住所１",
      nullable: true,
      errorMessage: util.stringErrorMessage("住所１", {
        required: false,
        maxLength: validateConstant.LENGTH.住所１,
      }),
    },
    住所２: {
      type: "string",
      maxLength: validateConstant.LENGTH.住所２,
      title: "住所２",
      nullable: true,
      errorMessage: util.stringErrorMessage("住所２", {
        required: false,
        maxLength: validateConstant.LENGTH.住所２,
      }),
    },
    住所３: {
      type: "string",
      maxLength: validateConstant.LENGTH.住所３,
      title: "住所３",
      nullable: true,
      errorMessage: util.stringErrorMessage("住所３", {
        required: false,
        maxLength: validateConstant.LENGTH.住所３,
      }),
    },
    電話番号: {
      type: "string",
      maxLength: validateConstant.LENGTH.電話番号,
      title: "電話番号",
      nullable: true,
      errorMessage: util.stringErrorMessage("電話番号", {
        required: false,
        maxLength: validateConstant.LENGTH.電話番号,
      }),
    },
    FAX番号: {
      type: "string",
      maxLength: validateConstant.LENGTH.電話番号,
      title: "FAX番号",
      nullable: true,
      errorMessage: util.stringErrorMessage("FAX番号", {
        required: false,
        maxLength: validateConstant.LENGTH.電話番号,
      }),
    },
    集計荷主コード: {
      type: "string",
      maxLength: validateConstant.LENGTH.汎用区分コード,
      title: "集計荷主",
      nullable: true,
      errorMessage: util.stringErrorMessage("集計荷主", {
        required: false,
        maxLength: validateConstant.LENGTH.汎用区分コード,
      }),
    },
    荷主担当者: {
      type: "string",
      maxLength: validateConstant.LENGTH.一般名称,
      title: "荷主担当者",
      nullable: true,
      errorMessage: util.stringErrorMessage("荷主担当者", {
        required: false,
        maxLength: validateConstant.LENGTH.一般名称,
      }),
    },
    インボイス登録番号: {
      type: "string",
      maxLength: validateConstant.LENGTH.インボイス登録番号,
      title: "インボイス登録番号",
      nullable: true,
      errorMessage: util.stringErrorMessage("インボイス登録番号", {
        required: false,
        maxLength: validateConstant.LENGTH.インボイス登録番号,
      }),
    },
    歩合掛率: {
      type: "number",
      minimum: 0,
      title: "歩合掛率",
      nullable: false,
      errorMessage: util.stringErrorMessage("歩合掛率", {
        required: true,
      }),
    },
    更新日時: {
      type: "string",
      minLength: 1,
      title: "更新日時",
      errorMessage: util.stringErrorMessage("更新日時", {
        required: true,
      }),
    },
  },
  required: ["更新日時", "荷主コード", "荷主名", "荷主略称1", "歩合掛率"],
}
